import { useCallback } from "react";
import { store } from "../../../store";
import { useFetchAction, type UseFetchActionReturn } from "../utils";
import type { PedestrianDevice } from "src/api";

export const useFetchPedestrianDevice = (
    pedestrianDeviceId?: string | null,
): UseFetchActionReturn<PedestrianDevice | undefined> => {
    const fetchPedestrianDevice: () => Promise<PedestrianDevice | undefined> = useCallback(() => {
        if (pedestrianDeviceId) {
            return store.pedestrianDevicesApi.routesPedestrianDevicesReadPedestrianDevice({
                pedestrianDeviceId,
            });
        } else {
            return Promise.resolve(undefined);
        }
    }, [pedestrianDeviceId]);
    return useFetchAction(fetchPedestrianDevice);
};
